<template>
  <div class="col-lg-4 col-md-6 col-12" >
    <div class="pb-0 card-header">
      <div class="d-lg-flex">
        <i class="fa-solid fa-industry icon-primary mt-2"></i><h6 class="ms-2 mb-3">{{ $t('key_purchaseManufacturerInfo_manufacturerInformation') }}</h6>
      </div>
    </div>
    <div class="pb-0 card-body">
      <ul v-if="!!purchase" class="list-group">
        <li class="list-group-item border-0 d-flex p-4 mb-2 bg-gray-100 border-radius-lg">
          <div class="d-flex flex-column">
            <h6 class="mb-3 text-sm text-primary">{{ purchase.end_customer.name }}</h6>
            <span class="mb-2 text-xs">
              {{ $t('key_purchaseManufacturerInfo_manufacturerName') }}:
              <span class="text-primary ms-2 font-weight-bold">{{ purchase.end_customer.contact }}</span>
            </span>
            <span class="mb-2 text-xs">
              {{ $t('key_purchaseManufacturerInfo_manufacturerVatNumber') }}:
              <span class="text-primary ms-2 font-weight-bold">{{ purchase.end_customer.vat }}</span>
            </span>
            <span class="mb-2 text-xs">
              {{ $t('key_purchaseManufacturerInfo_manufacturerAddress') }}:
              <span class="text-primary font-weight-bold ms-2">
                <a class="text-primary" :href="`https://www.google.com/maps?q=${encodeURIComponent(getFullAddress(purchase.end_customer.address))}`" target="_blank">
                  {{ getFullAddress(purchase.end_customer.address) }}
                </a>
              </span>
            </span>
            <span class="mb-2 text-xs">
              {{ $t('key_purchaseManufacturerInfo_manufacturerPhone') }}:
              <span class="text-primary ms-2 font-weight-bold">
                <a class="text-primary" :href="`tel:${purchase.end_customer.phone}`">
                  {{ purchase.end_customer.phone }}
                </a>
              </span>
            </span>
            <span class="text-xs">
              {{ $t('key_purchaseManufacturerInfo_manufacturerEmail') }}:
              <span class="text-primary ms-2 font-weight-bold">
                <a class="text-primary" :href="`mailto:${purchase.end_customer.email}`">
                  {{ purchase.end_customer.email }}
                </a>
              </span>
            </span>
          </div>
        </li>
      </ul>
    </div>
    <div class="pb-0 card-footer" />
  </div>
</template>

<script>

export default {
  name: "PurchaseManufacturerInfo",
  components: {
  },
  props: {
    purchase: {
      type: Object,
      default: null,
    },
  },  
  data() {
    return {};
  },
  methods: {
    getFullAddress(address) {
      return (address.street + " " + address.postal_code + " " + address.town + " " + address.province + " " + address.country);
    }
  }
};

</script>

<style>

  .icon-primary {
    color: #4A7062 !important;
  }

</style>